<!-- 盘点 -->
<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <div class="search-name">盘点单号</div>
                <el-input v-model.trim="searchData.InvenCode" clearable size="small" class="search-item" placeholder="盘点单号"></el-input>
                <div class="search-name">仓库</div>
                <el-select v-model="searchData.WarehouseName" @visible-change="getWarehouse" :loading="loading" class="search-item" size="small" filterable clearable remote>
                    <el-option value label="全部"></el-option>
                    <el-option v-for="optionItem in warehouseList" :label="optionItem.WarehouseName" :key="optionItem.WarehouseId" :value="optionItem.WarehouseName"
                        ><span style="float: left">{{ optionItem.WarehouseName }}</span>
                        <span v-if="optionItem.Type == 1" style="float: right; color: #8492a6; font-size: 13px">（前置仓）</span></el-option
                    >
                </el-select>
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询 (Enter)</el-button>
                <el-button size="small" class="search-btn btn-primary" @click="showSearchDialog">更多条件（F2）</el-button>
                <el-button size="small" icon="el-icon-plus" class="search-btn btn-primary" @click="gotoInventoryEdit(3)" v-if="permission.add">{{ permission.add }}（F3）</el-button>
                <el-button size="small" icon="el-icon-document" class="search-btn btn-primary" @click="showAllDetails()" v-if="permission.checkDetails">{{ permission.checkDetails }}（F4）</el-button>
                <el-button size="small" icon="el-icon-document" class="search-btn btn-primary" @click="gotoInvenCheckRecord()" v-if="permission.checkInvenRecords">{{
                    permission.checkInvenRecords
                }}（F5）</el-button>
            </div>
        </div>
        <div class="table-ctn">
            <el-table ref="refTable" :header-cell-style="{ background: '#F2F6FC' }" :data="tableData" border style="width: 100%" @cell-dblclick="handleDBClick">
                <el-table-column show-overflow-tooltip width="180px" prop="InvenCode" label="盘点单号"></el-table-column>
                <el-table-column show-overflow-tooltip label="盘点仓库" width="180px"
                    ><template slot-scope="scope"
                        >{{ scope.row.WarehouseNameSet }} <span v-if="scope.row.IsTuoGuan == 1" style="color: #8492a6">(前置仓)</span></template
                    ></el-table-column
                >
                <el-table-column show-overflow-tooltip width="160px" prop="InvenTime" label="盘点时间"></el-table-column>
                <el-table-column show-overflow-tooltip width="110px" prop="StateName" label="状态"></el-table-column>
                <el-table-column show-overflow-tooltip width="90px" prop="InvenCount" label="盘点项数"></el-table-column>
                <el-table-column show-overflow-tooltip width="100px" prop="InvenLabels" label="盘点标签数"></el-table-column>
                <el-table-column show-overflow-tooltip width="100px" prop="InvenSource" label="盘点来源">
                    <template slot-scope="scope">
                        <span v-if="scope.row.InvenSource == '计划内'">
                            {{ scope.row.InvenSource }}
                        </span>
                        <span v-else style="color: #e6a23c"> {{ scope.row.InvenSource }} </span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="InventorName" width="90px" label="创建人"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="250px" prop="InvenResult" label="盘点备注"></el-table-column>
                <el-table-column show-overflow-tooltip width="160px" prop="FiledTime" label="归档时间"></el-table-column>
                <el-table-column label="操作" :autoWidth="true">
                    <template slot-scope="scope">
                        <div class="ops-ctn">
                            <el-button
                                v-if="permission.edit && scope.row.IsCanUpdate && scope.row.IsTuoGuan == 0"
                                title="编辑"
                                size="mini"
                                type="text"
                                @click="gotoInventoryEdit(2, scope.row)"
                                >{{ permission.edit }}</el-button
                            >
                            <el-button
                                v-if="permission.submit && scope.row.IsCanSubmit && scope.row.IsTuoGuan == 0"
                                title="提交"
                                size="mini"
                                type="text"
                                @click="submitInventory(scope.row)"
                                >{{ permission.submit }}</el-button
                            >
                            <el-button v-if="permission.reject && scope.row.IsCanReject" title="驳回" size="mini" type="text" style="color: orange" @click="reject(scope.row)">{{
                                permission.reject
                            }}</el-button>
                            <el-button v-if="permission.archive && scope.row.IsCanArchive" title="归档" size="mini" type="text" @click="gotoInventoryEdit(4, scope.row)">{{
                                permission.archive
                            }}</el-button>
                            <el-button v-if="permission.export" title="导出" size="mini" type="text" @click="exportForm(scope.row)">{{ permission.export }}</el-button>
                            <el-button v-if="permission.checkLabels && scope.row.InvenLabels > 0" title="查看盘点相关的标签" size="mini" style="color: orange" type="text" @click="showLabelDetails(scope.row)">{{ permission.checkLabels }}</el-button>
                            <el-button v-if="permission.del && scope.row.IsCanDelete" title="删除" size="mini" type="text" style="color: red" @click="delInventory(scope.row)">{{
                                permission.del
                            }}</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.Page"
                :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                :page-size="searchData.Limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
        <el-dialog
            :close-on-click-modal="false"
            title="盘点单搜索"
            :visible.sync="dialogVisible"
            width="400px"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="search-invenOs-dialog"
            custom-class="search-item-dialog"
            style="margin-left: -170px"
        >
            <div class="dialog-content" v-if="dialogVisible">
                <el-form ref="form" label-position="left" label-width="70px">
                    <el-form-item label="状态">
                        <el-select v-model="searchData.State" class="search-item" style="width: 100%" size="small" filterable clearable placeholder="请选择">
                            <el-option v-for="item in stateList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="创建人">
                        <el-select v-model="searchData.OperId"  @visible-change="getSIdList" class="search-item" style="width: 100%" size="small" filterable clearable placeholder="请选择">
                            <el-option v-for="item in sIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="创建时间">
                        <el-date-picker
                            size="small"
                            style="width: 100%"
                            v-model="datetime"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            @change="onDateTimeSelect"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="归档时间">
                        <el-date-picker
                            size="small"
                            style="width: 100%"
                            v-model="datetime2"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            @change="onDate2TimeSelect"
                        ></el-date-picker>
                    </el-form-item>
                </el-form>
                <div class="dialog-footer">
                    <el-button class="btn-primary" size="small" @click="handleSearch">查询（Enter）</el-button>
                    <el-button size="small" @click="resetSearch">重置</el-button>
                    <el-button size="small" @click="closeSearchDialog">关闭（Esc）</el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="盘点商品明细" :visible.sync="detailsVisible" width="1300px">
            <div class="dialog-content" v-if="detailsVisible">
                <invenOrderDetails ref="invenOrderDetails"></invenOrderDetails>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="查看盘点标签" :visible.sync="showLabelsDialog" width="1200px"
            append-to-body>
            <div class="dialog-content" v-if="showLabelsDialog">
                <checkGoodsLabels @closeDialog="closeLabelsDialog" :InvensId="invenId"></checkGoodsLabels>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import breadcrumb from '@/components/common/breadcrumb';
import invenOrderDetails from '@/components/business/goods/invenOrderDetails';
import checkGoodsLabels from '@/components/business/goods/checkInvenLabels.vue';
import mixin from '@/mixins/mixin';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [mixin, pageLimitMixin],
    name: '',
    components: {
        breadcrumb,
        elTableColumn,
        invenOrderDetails,
        checkGoodsLabels
    },
    data() {
        return {
            datetime: [],
            datetime2:[],
            dialogVisible: false,
            detailsVisible: false,
            showLabelsDialog: false,
            invenId:'',
            loading: false,
            warehouseList: [],
            sIdList:[],
            searchData: {
                InvenCode: '',
                StartDate: '',
                State:'',
                OperId:'',
                EndDate: '',
                FStartDate: '',
                FEndDate: '',
                WarehouseName: '',
                Page: 1,
                Limit: this.commonPageSize
            },
            stateList: [
                { Text: '全部', Value: '' },
                { Text: '未盘点完成', Value: '0' },
                { Text: '已盘点完成', Value: '1' },
                { Text: '驳回', Value: '2' },
                { Text: '已归档', Value: '3' },
            ],
            tableData: [],
            tableDataLength: 0,
            permission: {},
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
        };
    },
    watch: {
        NeedRefresh(value) {
            if (value) {
                this.$store.commit('updateNeedRefresh', false);
                this.getTableData();
            }
        }
    },
    computed: {
        NeedRefresh() {
            return this.$store.state.needRefresh;
        }
    },
    activated() {
        if (this.$store.state.needRefresh) {
            this.$store.commit('updateNeedRefresh', false);
            this.getTableData();
        }
    },
    beforeRouteLeave(to, from, next) {
        document.removeEventListener('keydown', this.handleKeyEvent);
        next();
    },
    created() {
        document.addEventListener('keydown', this.handleKeyEvent);
    },
    mounted() {
        this.permission = this.$util.getPermission('inventory');
        this.getTableData();
    },
    methods: {
        handleKeyEvent(e) {
            let key = window.event.keyCode;
            let that = this;
            //F2
            if (key === 113) {
                e.preventDefault();
                that.dialogVisible = true;
                return;
            }
            //F3
            if (key === 114) {
                e.preventDefault();
                that.gotoInventoryEdit(3);
                return;
            }
            //F4
            if (key === 115) {
                e.preventDefault();
                that.showAllDetails();
                return;
            }
            //F5
            if (key === 116) {
                e.preventDefault();
                that.gotoInvenCheckRecord();
                return;
            }
            if (key === 27) {
                if (that.dialogVisible) that.dialogVisible = false;
                if (that.detailsVisible) that.detailsVisible = false;
                return;
            }
            if (key === 13) {
                that.handleSearch();
                return;
            }
            //左键
            if (key == 37) {
                if (this.searchData.Page > 1) {
                    this.searchData.Page -= 1;
                    this.getTableData();
                }
                return;
            }
            //右键
            if (key == 39) {
                if (this.searchData.Page < Math.ceil(this.tableDataLength / this.searchData.limit)) {
                    this.searchData.Page += 1;
                    this.getTableData();
                }
                return;
            }
        },
        // 驳回
        reject(row) {
            let that = this;
            this.$util.elConfirm({
                content: '确定要驳回这条盘点吗?',
                noMsg: true,
                confirm() {
                    that.$util
                        .axiosPost({
                            url: `/api/EntpCheckOrder/Reject?Id=${row.InvensId}`
                        })
                        .then(res => {
                            if (res.errcode == 0) {
                                that.$util.successMsg('驳回成功');
                                that.getTableData();
                            }
                        });
                }
            });
        },
        // 导出
        exportForm(row) {
            this.$util.exportFile({
                url: '/api/EntpCheckOrder/Export',
                data: {
                    InvensId: row.InvensId
                }
            });
        },
        submitInventory(row) {
            let that = this;
            this.$util.elConfirm({
                content: '确定要提交这条盘点吗?',
                noMsg: true,
                confirm() {
                    that.$util
                        .axiosPost({
                            url: `/api/EntpCheckOrder/Submit?Id=${row.InvensId}`
                        })
                        .then(() => {
                            that.$util.successMsg('提交成功');
                            that.getTableData();
                        });
                }
            });
        },
        // 删除
        delInventory(row) {
            let that = this;
            this.$util.elConfirm({
                content: '确定要删除这条盘点吗?',
                noMsg: true,
                confirm() {
                    that.$util
                        .axiosPost({
                            url: `/api/EntpCheckOrder/Delete?Id=${row.InvensId}`
                        })
                        .then(() => {
                            that.$util.successMsg('删除成功');
                            that.getTableData();
                        });
                }
            });
        },
        gotoInventoryEdit(type, row) {
            let InvensId = row ? row.InvensId : '';
            this.$router.push(`/inventoryManage/checkInventory/edit?type=${type}&InvensId=${InvensId}`);
        },
        gotoInvenCheckRecord() {
            this.$router.push(`/inventoryManage/checkInventory/checkRecords`);
        },
        getTableData() {
            this.$util
                .axiosGet({
                    url: '/api/EntpCheckOrder/GetList',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (res.errcode != 201) {
                        if (!data) data = [];
                        this.tableData = data;
                        this.tableDataLength = res.count;
                    }
                });
        },
        // 获取仓库列表
        getWarehouse() {
            if(this.warehouseList.length == 0){
                this.$util.getWarehouse().then(data => {
                    this.warehouseList = data;
                });
            }
        },
        resetSearch() {
            this.searchData = {
                InvenCode: '',
                State:'',
                OperId:'',
                StartDate: '',
                EndDate: '',
                FStartDate: '',
                FEndDate: '',
                WarehouseName: '',
                Page: 1,
                Limit: this.commonPageSize
            };
            this.datetime = [];
            this.datetime2 = [];
        },
        handleSearch() {
            this.searchData.Page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.Page = 1;
            this.searchData.Limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.Page = val;
            this.getTableData();
        },
        handleDBClick(event) {
            if (event) {
                this.gotoInventoryEdit(1, event);
            }
        },
        closeSearchDialog() {
            this.dialogVisible = false;
        },
        showSearchDialog() {
            this.dialogVisible = true;
        },
        getSIdList() {
            if(this.sIdList.length == 0){
                this.$util.getSIdList().then(data => {
                    this.sIdList = data;
                });
            }
        },
        onDateTimeSelect(val) {
            if (val != null) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        onDate2TimeSelect(val) {
            if (val != null) {
                this.searchData.FStartDate = val[0];
                this.searchData.FEndDate = val[1];
            } else {
                this.searchData.FStartDate = '';
                this.searchData.FEndDate = '';
            }
        },
        showAllDetails(){
            this.detailsVisible = true;
        },
        //关闭订单弹出层
        closeLabelsDialog() {
            this.invenId = '';
            this.showLabelsDialog = false;
        },
        // 打印
        showLabelDetails(row) {
            if (row) {
                this.invenId = row.InvensId;
                this.showLabelsDialog = true;
            } else {
                this.$util.warningMsg('请选择盘点单进行查看');
                return;
            }
        },
    }
};
</script>
<style lang="less">
#search-invenOs-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;
    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }
    .search-item-dialog {
        width: 340px;
        height: auto;
        .dialog-footer {
            text-align: right;
        }
        .el-form-item {
            margin-bottom: 0;
        }
    }
    .el-dialog__body {
        height: calc(100% - 54px);
        overflow: auto;
    }
}
</style>